import API from '@/views/Fdc/Apis/'
import EqpTree from '@/components/EqpTree/EqpTree'
import Dayjs from 'dayjs'

export default {
  name: 'SpcModelStatus',
  components: {
    EqpTree
  },
  mounted () {
  },
  methods: {
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      if (this.isRealTime) {
        this.selectedTreeNode = node
      }
    },
    /**
     * Model Status List 조회
     * 현재 선택한 Tree node 조회 조건 및 조회 기간을 기준으로 List를 조회합니다.
     */
    searchModelStatus () {
      if (this.selectedTreeNode.detail.eqpModel === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP Model']))
        return
      }

      let node = this.selectedTreeNode
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      // 조회 조건
      let param = {
        fab: node.detail.fab,
        area: node.detail.area,
        eqpModel: node.detail.eqpModel,
        startDt: Dayjs(this.fromDate).format('YYYYMMDD') + '000000',
        endDt: Dayjs(this.toDate).format('YYYYMMDD') + '235959'
      }

      this.selectVO = param

      this.getList(param)
    },
    /**
     * Model Status List 조회 API 실행
     * @param {Object} param 조회 조건(fab, area, eqpModel, startDt, endDt)
     */
    async getList (param) {
      let response = await API.Report.getSpcModelStatus(param)
      this.rowData = response
    },
    /**
     * Model Status Grid Refresh
     * 이전 Tree node 조회 조건 및 조회 기간을 기준으로 List를 조회합니다.
     */
    refresh () {
      // console.log('refresh param', this.selectVO)
      if (this.searchTreeNode) { // }) && this.searchTreeNode.length !== 0) {
        this.getList(this.selectVO)
      }
    },
    /**
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportExcel () {
      this.$refs.spcModelStatusGrid.gridApi.exportDataAsCsv({
        fileName: 'SpcModelStatus.csv'
      })
    }
  },
  data () {
    return {
      isRealTime: true,
      nodeObj: null,
      selectedTreeNode: null,
      searchTreeNode: null,
      selectVO: {}, // 조회 시점의 조건 저장

      // datepicker init
      fromDate: Dayjs().subtract(1, 'days').toDate(), // From Date (condition)
      fromMinDate: null, // From Date Min value
      fromMaxDate: new Date(), // From Date Max value
      toDate: new Date(), // To Date (condition)
      toMinDate: null, // Dayjs().subtract(2, 'days').toDate(), // To Date Min value
      toMaxDate: new Date(), // To Date Max value

      // grid init
      modelStatusColumns: [
        {
          headerName: '',
          children: [
            { headerName: 'FAB', field: 'fab', width: 100 },
            { headerName: 'Module', field: 'moduleId', width: 100 },
            { headerName: 'Param Alias', field: 'aliasName', width: 140 },
            { headerName: 'Recipe', field: 'recipeId', width: 90 },
            { headerName: 'Step', field: 'stepId', width: 90 },
            { headerName: 'Summary Type', field: 'smryType', width: 140 }
          ]
        },
        {
          headerName: 'Standard Infomation(Current)',
          children: [
            { headerName: 'Sigma', field: 'sigmaEstimate', width: 90, type: 'numericColumn' },
            { headerName: 'CL', field: 'clVal', width: 90, type: 'numericColumn' },
            { headerName: 'USL', field: 'uslVal', width: 90, type: 'numericColumn' },
            { headerName: 'UCL', field: 'uclVal', width: 90, type: 'numericColumn' },
            { headerName: 'LCL', field: 'lclVal', width: 90, type: 'numericColumn' },
            { headerName: 'LSL', field: 'lslVal', width: 90, type: 'numericColumn' },
            { headerName: 'Rule List', field: 'ruleList', width: 180 }
          ]
        },

        {
          headerName: 'Data 이력 통계',
          children: [
            { headerName: 'Count', field: 'count', width: 90, type: 'numericColumn' },
            { headerName: 'Avg', field: 'average', width: 90, type: 'numericColumn' },
            { headerName: '표준편차', field: 'std', width: 90, type: 'numericColumn' },
            { headerName: '알람 발생건수', field: 'faultCount', width: 110, type: 'numericColumn' },
            { headerName: 'Cp', field: 'cp', width: 90, type: 'numericColumn' },
            { headerName: 'Cpu', field: 'cpu', width: 90, type: 'numericColumn' },
            { headerName: 'Cpl', field: 'cpl', width: 90, type: 'numericColumn' },
            { headerName: 'Cpk', field: 'cpk', width: 90, type: 'numericColumn' }
          ]
        }

      ],
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: []
      // mergeHeaders: [ // Header를 2줄로 표시할 때 Merge 할 Header를 받습니다. Array의 length가 있으면 일단 header를 모두 2줄로 표시합니다
      //   'fab',
      //   'moduleId',
      //   'aliasName',
      //   'recipeId',
      //   'stepId',
      //   'smryType'
      // ],
      // mergeHeadersTitle: [ // mergeHeaders 의 값이 있을 때, merge되지 않는 header의 title
      //   'Standard Infomation(Current)',
      //   'Standard Infomation(Current)',
      //   'Standard Infomation(Current)',
      //   'Standard Infomation(Current)',
      //   'Standard Infomation(Current)',
      //   'Standard Infomation(Current)',
      //   'Standard Infomation(Current)',
      //   'Data 이력 통계',
      //   'Data 이력 통계',
      //   'Data 이력 통계',
      //   'Data 이력 통계',
      //   'Data 이력 통계',
      //   'Data 이력 통계',
      //   'Data 이력 통계',
      //   'Data 이력 통계'
      // ]
    }
  }
}
